var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    [
      _c("template", { slot: "header" }, [_vm._v("svg 图标选择器")]),
      _c(
        "div",
        { staticClass: "d2-mb" },
        [
          _c("p", { staticClass: "d2-mt-0 d2-mb-10" }, [
            _vm._v("一般用法 | " + _vm._s(_vm.icon || "未选择"))
          ]),
          _c("d2-icon-svg-select", {
            model: {
              value: _vm.icon,
              callback: function($$v) {
                _vm.icon = $$v
              },
              expression: "icon"
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "d2-mb" },
        [
          _c("p", { staticClass: "d2-mt-0 d2-mb-10" }, [
            _vm._v("用户可以输入 | " + _vm._s(_vm.icon2 || "未选择"))
          ]),
          _c("d2-icon-svg-select", {
            attrs: { "user-input": true },
            model: {
              value: _vm.icon2,
              callback: function($$v) {
                _vm.icon2 = $$v
              },
              expression: "icon2"
            }
          })
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }